import { i18n } from "commonAssets/js/constants";
import { createElement } from "./createElement.js";
import { submitContactForm } from "./submitContactForm.js";

export const submitContactButton = (userLanguage) => {
    return createElement(
        "button",
        {
            type: "button",
            class: "btn btn-primary",
            id: "submitContactFormBtn",
            disabled: true,
        },
        [],
        i18n.getTranslation("submit_btn"),
        {
            click: (event) => {
                submitContactForm();
            },
        }
    );
};
